import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    color?: 'primary' | 'white' | 'gray';
    className?: string;
    fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'md',
    color = 'primary',
    className = '',
    fullScreen = false
}) => {
    const spinnerClass = `custom-spinner spinner-${size} spinner-${color} ${className}`;

    if (fullScreen) {
        return (
            <div className="custom-spinner-overlay">
                <div className={spinnerClass}></div>
            </div>
        );
    }

    return <div className={spinnerClass}></div>;
};
